import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { take } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

export interface UnidadesMedidaElemento {
  ID: string;
  Nome: string;
  Input: boolean;
}

@Component({
  selector: 'app-consulta-unidade-medida',
  templateUrl: './consulta-unidade-medida.component.html',
  styleUrls: ['./consulta-unidade-medida.component.scss', '../../styles/estilo.padrao.scss']
})
export class ConsultarUnidadeMedidaComponent implements OnInit {
  uid;
  bBtSalvar: boolean = false;

  displayedColumns: string[] = ['Nome', 'Consultar'];
  unidades: UnidadesMedidaElemento[] = [];
  unidadesSource;
  idUnidadeCadastrada;
  filtroTabela = "";

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute
  ) {
    this.uid = localStorage.getItem('uid');
    this.spinner.show('consultar-unidade-medida');

    //Pegar o unidade recém cadastrado
    this.activatedRoute.queryParams.subscribe(value => {
      const dado = value;
      if (dado.IDUnidade) {
        this.idUnidadeCadastrada = dado.IDUnidade;
      }
    });

  }

  ngOnInit(): void {

    this.usuarioService.getUnidadesMedidas(this.uid).pipe(take(1)).subscribe(snap => {
      this.unidades = [];

      if (snap.length > 0) {
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          if (item.key === this.idUnidadeCadastrada) {
            this.filtroTabela = dados.Nome;
          }

          this.unidades.push({
            ID: item.key,
            Nome: dados.Nome,
            Input: false,
          });
        });

        //Ordena alfabeticamente
        this.unidades.sort((a, b) => a.Nome.localeCompare(b.Nome));

        // this.unidades.sort(function (a, b) {
        //   if (a.Nome < b.Nome) { return -1; }
        //   if (a.Nome > b.Nome) { return 1; }
        //   return 0;
        // });

        // this.usuarioService.setLog("Consulta de unidades de medidas", null, this.uid);


        this.unidadesSource = new MatTableDataSource(this.unidades);
        this.unidadesSource.paginator = this.paginator;

        if (this.idUnidadeCadastrada) {
          this.unidadesSource.filter = this.filtroTabela;
        }

        setTimeout(() => this.spinner.hide('consultar-unidade-medida'), 300);
      } else {
        this.toastr.error("Não foi possível localizar as unidades de medidas!", 'Erro');
        setTimeout(() => this.spinner.hide('consultar-unidade-medida'), 300);
      }
    });
  }

  async atualizar() {
    console.log(this.unidades)
    this.spinner.show('default');

    const map = this.unidades;

    let b = true;
    for (let i = 0; i < map.length; i++) {
      if (map[i].Input && map[i].Nome.length === 0) {
        b = false;
      }
    };

    if (b) {
      try {

        await Promise.all(map.map(async (value) => {
          if (value.Input) {
            const contents = await this.usuarioService.updateUnidadesMedidas(this.uid, value.Nome.trim(), value.ID).then(resp => {
              return;
            });
          } else
            return;

        })).then(resp => {

          this.toastr.success('Unidade de medida atualizada!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

          this.usuarioService.setLog("Alteração de Unidade de Medida", map, this.uid);

          setTimeout(() => {
            this.spinner.hide('default');
            this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
              this.router.navigate(["/pages/consultar-unidade-medida"]));
            this.toastr.clear();
          }, 800);
        });

      } catch (e) {
        console.log(e)
        this.spinner.hide('default');
        this.usuarioService.setLog("Erro ao alterar Unidade de Medida. Erro: " + e, map, this.uid);

        this.toastr.error('Erro ao atualizar Unidade de Medida!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/pages/consultar-unidade-medida"]));
      }
    } else {
      this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      setTimeout(() => this.spinner.hide('default'), 500);
    }
  }

  editarUnidadeMedida(dados) {
    const index = this.unidades.indexOf(dados)
    this.unidades[index].Input = true;
    this.bBtSalvar = true;
    setTimeout(() => document.getElementById(dados.ID).focus(), 100);
  }

  aplicarFiltroTabela(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.unidadesSource.filter = filterValue.trim().toLowerCase();

    if (this.unidadesSource.paginator) {
      this.unidadesSource.paginator.firstPage();
    }
  }

  voltar() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/consultar-unidade-medida"]));
  }
}

